import { render, staticRenderFns } from "./CookieElement.vue?vue&type=template&id=efaf6678&scoped=true"
import script from "./CookieElement.vue?vue&type=script&lang=js"
export * from "./CookieElement.vue?vue&type=script&lang=js"
import style0 from "./CookieElement.vue?vue&type=style&index=0&id=efaf6678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaf6678",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ControllerCookie: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerCookie.js').default})
